import * as React from 'react';
import { ComponentType } from 'react';
import { connect } from "react-redux";
import { routerActions } from 'react-router-redux';
import ReactTable, { RowInfo } from 'react-table';
import { bindActionCreators } from "redux";
import { InlineLoading } from 'src/components/common';
import { HealthDistrictsBreadcrumbs } from 'src/helpers/breadcrumbHelper';
import { findLookup } from 'src/helpers/lookupHelper';
import RouterHoc, { IRouterActions, IRouterProps } from 'src/hoc/RouterHoc';
import * as HealthDistrictActions from '../../../actions/healthDistrict';
import * as NavigationActions from '../../../actions/navigation';
import * as PagingActions from '../../../actions/pages/pagingPage';
import { FormFilterInput } from '../../../components/form';
import { RestrictedLayout } from "../../../components/layouts/index";
import { Link } from "../../../components/routing/index";
import { FontAwesomeIcon, FontAwesomeIcons } from "../../../constants/fontAwesomeIcons";
import { PAGE_SIZE_OPTIONS } from "../../../constants/reactTableConstants";
import * as Dtos from '../../../dtos/Tmd.dtos';
import { RequestState } from "../../../enumerations/RequestState";
import * as AuthenticationHelper from '../../../helpers/authentication';
import { IFormFilter, ITmdState } from "../../../reducers/index";

import './HealthDistrictsPage.scss';

interface IHealthDistrictsPageParams {}

interface IHealthDistrictsPageProps extends IRouterProps<IHealthDistrictsPageParams> {

    // From state
    formFilter: IFormFilter;
    formLength: number;
    healthDistricts: Dtos.HealthDistrict[];
    loadingHealthDistricts: boolean;
    loadHealthDistrictsSuccess: boolean;
    loadHealthDistrictsFailure: boolean;

    user: Dtos.User;
    permissions?: Dtos.PersonnelTmdPermissions[];
    lookups: Dtos.Lookup[];

    pageSize: number;
}

interface IHealthDistrictsPageActions extends IRouterActions {
    clearHealthDistricts: HealthDistrictActions.IHealthDistrictClearActionCreator;
    loadHealthDistricts: HealthDistrictActions.IHealthDistrictLoadActionCreator;

    navigate: typeof routerActions.push;
    navigateReplace: typeof routerActions.replace;

    filter: HealthDistrictActions.IHealthDistrictFilterActionCreator;

    setPageSize: PagingActions.IPagingPageSizeChangedStateActionCreator;

    setBreadcrumbs: NavigationActions.ISetBreadcrumbsActionCreator;
    setDrawerItems: NavigationActions.ISetDrawerItemsActionCreator;

}

type HealthDistrictsPageProps = IHealthDistrictsPageProps & IHealthDistrictsPageActions;

class HealthDistrictsPage extends React.PureComponent<HealthDistrictsPageProps, any> {

    constructor(props: HealthDistrictsPageProps) {
        super(props);

        this.clearHealthDistricts = this.clearHealthDistricts.bind(this);

        this.state = {
            exportToggle: false
        };
    }

    componentDidMount() {
        const {
            loadHealthDistricts,
            setBreadcrumbs,
            setDrawerItems
        } = this.props;
        

        loadHealthDistricts();

        setDrawerItems([]);
        setBreadcrumbs(HealthDistrictsBreadcrumbs());
    }

    componentWillReceiveProps(_nextProps: HealthDistrictsPageProps) {
    }

    componentDidUpdate(_prevProps: HealthDistrictsPageProps, _prevState) {
    }

    componentWillUpdate(_nextProps: HealthDistrictsPageProps) {
    }

    componentWillUnmount() {
        this.clearHealthDistricts();
    }

    clearHealthDistricts() {
        this.props.clearHealthDistricts();
    }

    showHealthDistricts(): boolean {
        const {
            loadingHealthDistricts,
            loadHealthDistrictsSuccess
        } = this.props

        if (!loadingHealthDistricts && loadHealthDistrictsSuccess) {
            return true;
        }

        return false;
    }

    render() {

        const {
            loadingHealthDistricts
        } = this.props;

        return (
            <RestrictedLayout
                anyMatchpermission={Dtos.Permission.HealthDistrictView}
                loading={loadingHealthDistricts}
            >
                {this.renderContent()}
            </RestrictedLayout>
        );
    }

    renderContent() {
        const {
            permissions
        } = this.props;

        const canCreate = AuthenticationHelper.hasPermission(permissions, Dtos.Permission.HealthDistrictCreate);

        return (
            <div>
                <div className="row">
                    <div className={"col-auto mb-2"}>
                        <h1>Health District Manager</h1>
                    </div>
                    <div className="col d-flex justify-content-end align-items-stretch" style={{ height: '38px' }}>
                        <FormFilterInput formFilter={this.props.formFilter} onFilter={e => this.props.filter(e)} />

                        {canCreate && 
                            <>
                                <Link className={"btn btn-primary"} url={"/settings/healthdistricts/create"}>Create</Link>
                            </>
                        }
                    </div>
                </div>
                {
                    !this.showHealthDistricts() ?
                        <InlineLoading absoluteCenter={true} size={50}/> :
                        null
                }
                {
                    this.showHealthDistricts() ?
                        <div className='card'>
                            <div className="patient-tables">
                                {
                                    this.createTable()
                                }
                            </div>
                        </div> :
                        null
                }
            </div>
        );
    }

    createTable() {

        const {
            healthDistricts,
            pageSize,
            setPageSize,
            permissions,
            lookups
        } = this.props

        if (!healthDistricts || healthDistricts.length == 0) {
            return (
                <div className='card card-shadow p-3'>
                    <div className="alert alert-info d-flex mb-0">
                        <div className="mr-2">
                            <FontAwesomeIcon icon={FontAwesomeIcons.Solid.INFO_SQUARE} fixedWidth />
                        </div>
                        <span>There are currently no health districts to view.</span>
                    </div>
                </div>
            );
        }

        const showPagination = healthDistricts.length > pageSize;

        return (
            <div className="table-wrapper">
                <ReactTable
                    data={healthDistricts}
                    pageSizeOptions={PAGE_SIZE_OPTIONS}
                    defaultPageSize={showPagination ? pageSize : healthDistricts.length}
                    pageSize={showPagination ? pageSize : healthDistricts.length}
                    showPagination={showPagination}
                    className="-striped -highlight -clickable"
                    noDataText="There are currently no health districts to display"
                    resizable={false}
                    onPageSizeChange={val => setPageSize(val)}
                    getTdProps={(state, rowInfo: RowInfo, _column, _instance) => {
                        return {
                            onClick: (e, handleOriginal) => {
                                const HealthDistrictId = rowInfo.original.id;
                                const canView = AuthenticationHelper.hasPermission(permissions, Dtos.Permission.HealthDistrictView, HealthDistrictId, undefined);
                                if (canView){
                                    const url: string = "/settings/healthdistricts/" + rowInfo.original.id + "/details";
                                    this.props.navigate(url);
                                }

                                if (handleOriginal) {
                                    handleOriginal()
                                }

                            }
                        }
                    }}
                    defaultSorted={[
                        {
                            id: "fullName",
                            desc: false
                        }
                    ]}
                    columns={[
                        {
                            id: "id",
                            Header: ' ',
                            accessor: "id",
                            maxWidth: 50,
                            Cell: (_props) => <FontAwesomeIcon size='lg' icon={FontAwesomeIcons.Duotone.HOSPITALS} fixedWidth />
                        },
                        {
                            id: "name",
                            Header: 'Name',
                            accessor: 'name',
                            Cell: (props) => <span>{props.value ?? props?.original?.name}</span>
                        },
                        {
                            id: "stateId",
                            Header: 'State',
                            accessor: 'stateId',
                            maxWidth: 300,
                            Cell: (props) => <span>{findLookup("HealthDistrict", "StateId", lookups)?.values?.find(x => x.id == props.value)?.value}</span>
                        }
                    ]}
                />
            </div>
        );
    }

}

const mapStateToProps = (state: ITmdState, ownProps: HealthDistrictsPageProps): IHealthDistrictsPageProps => {

    let permissions = state.user.userSummary ? state.user.userSummary.permissions : [];

    return {

        history: ownProps.history,
        location: ownProps.location,
        match: ownProps.match,

        healthDistricts: state.healthDistricts.formFilteredData!,
        formFilter: state.healthDistricts.formFilter,
        formLength: state.healthDistricts.formLength,
        lookups: state.healthDistricts.lookups,

        loadingHealthDistricts: state.healthDistricts.loadState && state.healthDistricts.loadState.status == RequestState.Pending,
        loadHealthDistrictsSuccess: state.healthDistricts.loadState && state.healthDistricts.loadState.status == RequestState.Success,
        loadHealthDistrictsFailure: state.healthDistricts.loadState && state.healthDistricts.loadState.status == RequestState.Failure,

        user: state.user.data,
        permissions: permissions,

        pageSize: state.pagingPage.pageSize
    };
};

const mapDispatchToProps = (dispatch, ownProps: HealthDistrictsPageProps): IHealthDistrictsPageActions => {
    return {
        navigate: ownProps.navigate,
        navigateReplace: ownProps.navigateReplace,

        loadHealthDistricts: bindActionCreators(HealthDistrictActions.LoadHealthDistrict, dispatch),
        clearHealthDistricts: bindActionCreators(HealthDistrictActions.Clear, dispatch),

        filter: bindActionCreators(HealthDistrictActions.Filter, dispatch),

        setPageSize: bindActionCreators(PagingActions.PageSizeChanged, dispatch),

        setBreadcrumbs: bindActionCreators(NavigationActions.SetBreadcrumbs, dispatch),
        setDrawerItems: bindActionCreators(NavigationActions.SetDrawerItems, dispatch)
    };
};

export default
    RouterHoc<IHealthDistrictsPageParams, HealthDistrictsPageProps>((connect(mapStateToProps, mapDispatchToProps)(HealthDistrictsPage) as unknown as ComponentType<HealthDistrictsPageProps>)) as ComponentType<any>;
